import { useI18n } from '@pique/i18n';
import { useMemo } from 'react';

export const useNavConfig = () => {
  const t = useI18n();
  return useMemo(
    () => [
      {
        title: t['com.pique.other-page.nav.official-website'](),
        path: 'https://app.pique.so',
      },
      {
        title: t['com.pique.other-page.nav.affine-community'](),
        path: 'https://community.pique.so/home',
      },
      {
        title: t['com.pique.other-page.nav.blog'](),
        path: 'https://app.pique.so/blog',
      },
      {
        title: t['com.pique.other-page.nav.contact-us'](),
        path: 'https://app.pique.so/about-us',
      },
    ],
    [t]
  );
};
